import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

// change style for vue select by using css var
import './vue-select.css';

Vue.component('vue-select', vSelect)
